import React, { useState } from 'react';
export const TableHeader = ({ columns, bulkActionEnabled, onSelectAllClicked, unCheckAll, onSorting }) => {
    const [selected, setSelected] = useState(false);
    const [sortBy, setSortBy] = useState('');
    const [sortDirection, setDirection] = useState('');
    React.useEffect(() => {
        if (unCheckAll) {
            setSelected(false);
            onSelectAllClicked(false)
        }
    }, [unCheckAll]);
    const handleSortClick = (value) => {
        let direction = ''
        if (sortBy != value)
            direction = 'desc'
        else if (sortBy == value && sortDirection == 'desc')
            direction = 'asc'
        let sort = direction == '' ? '' : value;
        setSortBy(sort)
        setDirection(direction);
        if (onSorting)
            onSorting(sort, direction)
    }
    const checkSortDirection = (col) => {
        return col.key == sortBy || col.sortName == sortBy ? 'sort ' + sortDirection : 'sort';
    }
    return (
        <tr>
            {
                bulkActionEnabled ? <th><input
                    type="checkbox"
                    className='table-check'
                    checked={selected}
                    onChange={() => { onSelectAllClicked(!selected); setSelected(!selected); }}
                /></th> : null
            }
            {columns.map((column, columnIndex) => (
                <th
                    key={`table-head-cell-${columnIndex}`}
                    style={{ width: column.width }}
                >
                    {column.sortEnabled ?
                        <div className='header-sort' onClick={() => handleSortClick(column.sortName ? column.sortName : column.key)}>
                            {column.title}
                            <i className={checkSortDirection(column)} />
                        </div>
                        : <div>{column.title}</div>}
                </th>
            ))}
        </tr>
    );
}
export default TableHeader;